var map = {
	"./DEFlag.png": 4148,
	"./FIFlag.png": 1138,
	"./IEFlag.png": 6083,
	"./NOFlag.png": 4608,
	"./PLFlag.png": 3548,
	"./SEFlag.png": 5480,
	"./UKFlag.png": 7520
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2483;